var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
import { TABLET_WIDTH } from '@codex/utils/constants';
var styles = (_a = {
        // form specific css
        radioBtn: (_b = {
                width: 107,
                height: 73,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 6,
                border: "solid 1px #4bb0dd",
                cursor: "pointer"
            },
            _b["& div"] = {
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                width: 60,
                paddingTop: 8
            },
            _b["& span"] = {
                fontSize: 14,
                fontWeight: "normal",
                fontStyle: "normal",
                fontStretch: "normal",
                lineHeight: 1,
                letterSpacing: "normal",
                textAlign: "center"
            },
            _b),
        jobItemsWrapper: {
            width: 455,
            display: "flex",
            justifyContent: "space-between",
            margin: '0 auto'
        },
        jobItem: {
            width: 200,
            height: 30,
            borderRadius: 27,
            border: "solid 1px #4bb0dd",
            padding: "0 14px",
            display: "flex",
            justifyContent: "space-between",
            boxSizing: "border-box",
            cursor: "pointer",
            alignItems: "center",
            marginBottom: 9,
            userSelect: 'none'
        },
        satisfactionPopoverContent: (_c = {
                width: 190
            },
            _c["& svg"] = {
                width: 13,
                height: 13
            },
            _c),
        inlineInputContainer: {
            display: "flex",
            alignItems: "flex-end",
            direction: "rtl"
        },
        WorkHourContainer: (_d = {
                display: 'flex',
                flexDirection: 'row-reverse'
            },
            _d["& article"] = {
                display: 'flex',
                alignItems: 'center',
            },
            _d),
        inlineInput: (_e = {
                border: "none",
                borderBottom: "1px solid",
                borderRadius: 0,
                textAlign: "center",
                paddingTop: 14,
                width: 92,
                display: "inline"
            },
            _e["&:focus"] = {
                boxShadow: "unset"
            },
            _e),
        antRowReverse: {
            display: 'flex',
            flexDirection: 'column-reverse'
        },
        withError: (_f = {},
            _f["& > div"] = {
                borderColor: "#f5222d"
            },
            _f),
        errorLabel: {
            color: "#f5222d"
        },
        info: (_g = {
                width: 14,
                height: 15,
                backgroundImage: "url(" + require("../../assets/images/info.png") + ")",
                display: "inline-block",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                position: "relative",
                top: 3,
                marginRight: 5
            },
            _g["&.ant-popover-open"] = {
                backgroundImage: "url(" + require("../../assets/images/info-active.png") + ")",
            },
            _g),
        bigSelect: (_h = {},
            _h["& div"] = {
                height: '54px !important',
            },
            _h["& .ant-select-selection-selected-value"] = {
                lineHeight: '54px !important',
            },
            _h),
        bigInput: {
            height: '54px !important'
        },
        radioGroup: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            direction: "rtl"
        },
        table: (_j = {
                direction: "rtl",
                textAlign: "right"
            },
            _j["& table"] = {
                marginTop: '4px !important',
            },
            _j["& th"] = {
                textAlign: "right",
                padding: "8px 16px !important",
            },
            _j["& tr td"] = (_k = {
                    padding: "6px 16px !important",
                    backgroundColor: "#FFF !important"
                },
                _k["&:last-child"] = {
                    borderLeftWidth: '0 !important'
                },
                _k),
            _j),
        face: {
            cursor: "pointer",
            height: 20,
            position: 'relative'
        },
        mobileFacesAndRatingWrapper: (_l = {
                boxShadow: "0 15px 39px 0 rgba(35, 65, 81, 0.31)",
                backgroundColor: "rgba(255, 255, 255, 0.94)",
                direction: "rtl",
                position: "absolute",
                width: "100vw",
                left: 0,
                transform: 'translateY(-100%)',
                textAlign: 'center',
                marginTop: -16
            },
            _l["& > article"] = {
                color: "#5a5a6c",
                fontSize: 16,
                margin: '12px 0 15px'
            },
            _l["& svg"] = {
                width: 36,
                height: 36,
                margin: '0 12px'
            },
            _l["& .ant-rate svg"] = {
                width: 28,
                height: 28,
            },
            _l["& .ant-rate-star"] = {
                marginRight: '0 !important'
            },
            _l["& .rating-labels"] = (_m = {
                    marginTop: 8
                },
                _m["& > div"] = {
                    display: 'inline-block',
                    width: 28,
                    margin: '0 12px',
                    textAlign: 'center',
                    fontSize: 14,
                    color: '#808080'
                },
                _m),
            _l),
        leftIcon: {
            textAlign: "left"
        },
        rightIcon: {},
        middleHeader: {
            textAlign: 'center',
            fontFamily: 'Assistant',
            fontSize: 28,
            lineHeight: 0.86,
            color: '#5a5a6c'
        },
        star: (_o = {
                width: 20,
                height: 20,
                position: 'relative',
                left: -7
            },
            _o["& svg"] = {
                width: '100%',
                height: '100%'
            },
            _o["& .label"] = {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#FFF',
                fontSize: 13
            },
            _o),
        middleSubHeader: (_p = {
                fontFamily: 'Assistant',
                fontSize: 16,
                lineHeight: 1.44,
                textAlign: 'center',
                color: '#5a5a6c',
                direction: "rtl"
            },
            _p['& p'] = {
                marginBottom: 3,
            },
            _p),
        description: {
            fontFamily: 'Assistant',
            fontSize: 22,
            fontWeight: 600,
            lineHeight: 1.09,
            textAlign: 'center',
            color: '#5a5a6c',
            margin: '25px 0',
            height: 24
        },
        iconsRow: {
            width: '100%'
        }
    },
    _a["@media screen and (max-width:" + TABLET_WIDTH + "px)"] = {
        leftIcon: {
            textAlign: 'left'
        },
        rightIcon: {},
        middleHeader: {
            fontSize: 20,
            lineHeight: 1.2,
        },
        middleSubHeader: (_q = {
                paddingTop: 17,
                fontSize: 14,
                lineHeight: 1.44
            },
            _q['& p'] = {
                marginBottom: 3,
            },
            _q),
        description: {
            fontSize: 18,
            lineHeight: 1.33,
            width: 189,
            height: 67,
            margin: '32px auto 0'
        },
        iconsRow: {
            paddingBottom: 14
        },
        radioGroup: (_r = {},
            _r["&.org"] = {
                justifyContent: "end",
            },
            _r["&:not(.org)"] = {
                justifyContent: "center"
            },
            _r.marginBottom = 1,
            _r),
        radioBtn: (_s = {
                width: 94,
                marginBottom: 10
            },
            _s["&:nth-child(3n-1)"] = {
                margin: "0px 9px 10px"
            },
            _s),
        table: (_t = {},
            _t["& th"] = {
                textAlign: "right",
                padding: "5px 16px !important",
            },
            _t),
        jobItemsWrapper: {
            width: 'auto',
            justifyContent: "center",
            flexWrap: 'wrap'
        }
    },
    _a);
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/components/SurvayForm/styles.ts
// module id = 1513
// module chunks = 0